export default __webpack_public_path__ + "static/media/femsa.39ae5d2e.png";